import React,{useState} from 'react';
import Panel from '../../../components/Panel/Panel';
import {JButton} from '../../../components/UI/JButton';
import JPanel from '../../../components/UI/JPanel';
import {JTextField} from '../../../components/UI/JTextField';

/** Reserved for the future server-authorized SVIP entitlement. No account is enabled yet. */
export function SVIPAutoFillButton(){
 const [denied,setDenied]=useState(false);
 return <>
  <JButton x={50} text="Auto Fill Souls" onClick={()=>setDenied(true)}/>
  {denied&&<Panel moveable={false} onClose={()=>setDenied(false)} style={{zIndex:10000}}>
    <JPanel size={{width:280,height:110}}>
      <JTextField size={{width:260,height:70}} position={{x:10,y:10}} text="คุณไม่ใช่สมาชิก SVIP ไม่สามารถใช้งานได้"/>
      <JButton size={{width:75,height:25}} position={{x:102,y:80}} text="Close" onClick={()=>setDenied(false)}/>
    </JPanel>
  </Panel>}
 </>;
}
